<template>

  <div>
    <el-form :model="formData" label-width="180px" :rules="rules">
      <el-row>
        <el-form-item label="设备名称：" prop="star">
          <el-input v-model="formData.device_name"  clearable disabled style="width: 250px">
          </el-input>
        </el-form-item>
        <el-form-item label="设备型号：" prop="star">
          <el-input v-model="formData.device_model" clearable disabled style="width: 250px">
          </el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="设备编号：" prop="star">
          <el-input v-model="formData.device_no"  clearable disabled style="width: 250px">
          </el-input>
        </el-form-item>
        <el-form-item label="设备资产编号：" prop="star">
          <el-input v-model="formData.device_asset_no" clearable disabled style="width: 250px">
          </el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="设备类型：" prop="star">
          <el-input v-model="formData.device_type_name" clearable disabled style="width: 250px">
          </el-input>
        </el-form-item>
        <el-form-item label="部门：" prop="star">
          <el-input v-model="formData.department" clearable disabled style="width: 250px">
          </el-input>
        </el-form-item>
      </el-row>
      <el-form-item label="A 生产线记录栏：" style="font-size: 15px;font-weight: bold;"></el-form-item>
      <el-form-item label="故障部位：" prop="star">
        <el-input v-model="formData.fault_location" clearable disabled style="width: 680px">
        </el-input>
      </el-form-item>
      <el-form-item label="故障现象：" prop="star">
        <el-checkbox-group v-model="formData.fault_phenomenon" disabled >
          <el-checkbox label="设备报警" />
          <el-checkbox label="线路破皮" />
          <el-checkbox label="配件损坏" />
          <el-checkbox label="漏油"  />
          <el-checkbox label="漏气"  />
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="其他故障现象：" prop="star">
        <el-input v-model="formData.other_fault_description" clearable disabled style="width: 680px">
        </el-input>
      </el-form-item>
      <el-form-item label="设备状态：" prop="star">
        <el-checkbox-group v-model="formData.device_status" disabled >
          <el-checkbox label="临时可运行" />
          <el-checkbox label="电源关闭" />
          <el-checkbox label="其它" />
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="其他设备状态：" prop="star">
        <el-input v-model="formData.other_device_status_description" clearable disabled style="width: 680px">
        </el-input>
      </el-form-item>
      <el-form-item label="报修状态：" prop="star">
        <el-input v-model="formData.repair_status" clearable disabled style="width: 680px">
        </el-input>
      </el-form-item>
      <el-form-item label="希望纳期：" prop="star">
        <el-input v-model="formData.want_delivery_date" clearable disabled style="width: 250px">
        </el-input>
      </el-form-item>
      <el-row>
        <el-form-item label="撤销用户：" prop="star">
          <el-input v-model="formData.repeal_user_name" clearable disabled style="width: 250px">
          </el-input>
        </el-form-item>
        <el-form-item label="撤销时间：" prop="star">
          <el-input v-model="formData.repeal_time" clearable disabled style="width: 250px">
          </el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="报修确认用户：" prop="star">
          <el-input v-model="formData.repair_affirm_user_name"  clearable disabled style="width: 250px">
          </el-input>
        </el-form-item>
        <el-form-item label="报修确认时间：" prop="star">
          <el-input v-model="formData.repair_affirm_time" clearable disabled style="width: 250px">
          </el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="制造科确认用户：" prop="star">
          <el-input v-model="formData.zz_affirm_user_name" clearable disabled style="width: 250px">
          </el-input>
        </el-form-item>
        <el-form-item label="制造科确认时间：" prop="star">
          <el-input v-model="formData.zz_affirm_time" clearable disabled style="width: 250px">
          </el-input>
        </el-form-item>
        <el-form-item label="制造科确认结果：" prop="star">
          <el-input v-model="formData.zz_affirm_result" clearable disabled style="width: 250px">
          </el-input>
        </el-form-item>
      </el-row>
      <el-form-item label="照片：" prop="star" disabled >
        <el-col :span="18" v-for="(item,index) in this.formData.imageIds" :key="index">
          <el-image :src="item" :preview-src-list="[item]"
                    style="width: 150px ;height: 150px;margin-top: 30px"
                    :initial-index="0" fit="cover" preview-teleported="true" />
        </el-col>
      </el-form-item>
    </el-form>


  </div>
</template>

<script>

export default {
  name: "EqRepairRequestZhiZaoDetails",
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    setting: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      loading: false,
      formData: {
      },


      rules: {
        star: [{required: true, message: '', trigger: 'blur'}],
      },
    }
  },
  computed: {},
  methods: {
    getRepairRequestData() {
      this.$http('eqRepairRequestZhiZaoService.getRepairSubmitRecord',this.parentData).then(data => {
        this.formData = data
      }, errMsg => {
        return this.$message.error("获取失败"+errMsg);
      })
    },

  },
  created() {
    this.getRepairRequestData()

  }
}
</script>

<style scoped>

</style>